import { UtilityBillFormData } from "types";
import { getWarningColorStateProps } from "utils";

export const getTextFieldNoErrorProps = (
  key: keyof UtilityBillFormData,
  isWarningFields?: Record<keyof UtilityBillFormData, boolean>,
) => (isWarningFields ? getWarningColorStateProps(key, isWarningFields) : {});

export const getIsWarningFields = (
  defaultValues: UtilityBillFormData,
  watchValues: UtilityBillFormData,
  nullValues: Record<string, string | number | null | undefined>,
) =>
  Object.keys(watchValues).reduce((acc, key) => {
    acc[key as keyof UtilityBillFormData] =
      key in nullValues
        ? defaultValues[key as keyof UtilityBillFormData] === nullValues[key] &&
        watchValues[key as keyof UtilityBillFormData] === nullValues[key]
        : !defaultValues[key as keyof UtilityBillFormData] &&
        !watchValues[key as keyof UtilityBillFormData];
    return acc;
  }, {} as Record<keyof UtilityBillFormData, boolean>);

